import { FC, useEffect, useState } from 'react';
// 组件
import { ProTable, ProForm } from '../antd';
import EditableCell from './subpage/editableCell';
// 方法
import ediTableColumnsHook from './hooks/ediTableColumnsHook';
// 常量
import { EdiTableVariableProps } from './interface';
import '../EdiTableCopy/style.less';
/** 可变类型可编辑表 */
const EdiTableVariable: FC<EdiTableVariableProps> = props => {
  const {
    columns,
    actionRef,
    dataSource: propsDataSource,
    maxHeight,
    ...restProps
  } = props;
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [form] = ProForm.useForm();
  const { columns: newColumns, editColumnNames } = ediTableColumnsHook(
    props,
    form,
  );
  useEffect(() => {
    setDataSource([]);
    setTimeout(() => {
      form.resetFields();
      setDataSource(propsDataSource ? [...propsDataSource] : []);
    });
  }, [propsDataSource]);
  // 获取dataSource
  const handleDataSource = () => {
    const currentDataSource: any[] = [];
    const formData = form.getFieldsValue(true);
    dataSource?.forEach((item, index) => {
      const itemData: any = {};
      editColumnNames.forEach(v => {
        itemData[v] = formData[`${v}_${index}`];
      });
      currentDataSource.push({
        ...item,
        ...itemData,
      });
    });
    return currentDataSource;
  };
  // 提交
  const handleSubmit = async () => {
    const newDataSource: any[] = [];
    try {
      const formData = await form.validateFields();
      dataSource?.forEach((item, index) => {
        const itemData: any = {};
        editColumnNames.forEach(v => {
          itemData[v] = formData[`${v}_${index}`];
        });
        newDataSource.push({
          ...item,
          ...itemData,
        });
      });
    } catch (errorInfo) {
      return false;
    }
    return newDataSource;
  };
  if (actionRef) {
    actionRef.current = {
      form,
      getDataSource: handleDataSource,
      submit: handleSubmit,
    };
  }
  return (
    <ProForm form={form} component={false}>
      <ProTable
        className="yb-editable"
        dataSource={dataSource}
        columns={newColumns}
        pagination={false}
        size="small"
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        // scroll={{
        //   scrollToFirstRowOnChange: true,
        //   y: maxHeight,
        // }}
        {...restProps}
      />
    </ProForm>
  );
};

EdiTableVariable.defaultProps = {
  maxHeight: 300,
  disabled: false,
};

export default EdiTableVariable;
